// extracted by mini-css-extract-plugin
module.exports = {"text":"FulfillmentConfirm__text___SHOaZ"};